export class ChangeUserPassword {
    constructor(public  UserId:number=null,
        public  OldPassword:string=null,
        public  NewPassword:string=null,
        public  VerifyPassword:string=null){

    }
}
